import React from "react";
import { TiltCard } from "./TiltCard";
import { AnimatedNumber } from "./AnimatedNumber";

export function Panel({ title, eyebrow, action, children, className = "", testId }) {
    return (
        <section data-testid={testId} className={`panel-elevated relative overflow-hidden ${className}`}>
            {(title || action) && (
                <header className="flex items-end justify-between px-5 pt-4 pb-3 border-b border-white/5">
                    <div>
                        {eyebrow && <div className="label-eyebrow mb-1">{eyebrow}</div>}
                        {title && <h3 className="font-display text-base text-white tracking-tight">{title}</h3>}
                    </div>
                    {action}
                </header>
            )}
            <div className="p-5">{children}</div>
        </section>
    );
}

export function StatTile({ label, value, sub, tone = "cyan", icon: Icon, testId }) {
    const toneMap = {
        cyan: "text-cyan-300",
        green: "text-emerald-400",
        amber: "text-amber-400",
        red: "text-rose-400",
        slate: "text-slate-200",
    };
    return (
        <TiltCard
            testId={testId}
            className="group panel-elevated card-lift relative p-5 overflow-hidden rounded-[4px]"
        >
            <div className="absolute -right-6 -top-6 w-32 h-32 rounded-full bg-cyan-500/5 blur-2xl pointer-events-none group-hover:bg-cyan-500/10 transition-colors duration-500" />
            <div className="flex items-start justify-between" style={{ transform: "translateZ(30px)" }}>
                <div className="label-eyebrow">{label}</div>
                {Icon && <Icon size={14} className="text-slate-500 group-hover:text-cyan-400 transition-colors duration-300" />}
            </div>
            <div
                className={`mt-3 font-display text-3xl tracking-tight ${toneMap[tone] || toneMap.cyan}`}
                style={{ transform: "translateZ(40px)" }}
            >
                <AnimatedNumber value={value} />
            </div>
            {sub && (
                <div
                    className="mt-1 text-[11px] font-mono text-slate-500 uppercase tracking-wider"
                    style={{ transform: "translateZ(20px)" }}
                >
                    {sub}
                </div>
            )}
        </TiltCard>
    );
}
